<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="`Hola, ${user.name}`" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-5">
			<HomeBalanceCard :summaries="results.summaries" :placeholder="loading" @select="select" />
			<HomeGoalSummary :goals="results.goals" />
			<HomeBirthdayCard :customers="results.birthdays" v-if="(results.birthdays ?? []).length > 0" />
			<HomeCustomerCard />
			<HomeSaleCard :sales="results.sales" :placeholder="loading" />
		</main>

		<HomeBalanceModalSelect ref="modalSelect" :balances="results?.balances" />
	</div>
</template>

<script>
	import { ref, computed, onMounted } from 'vue';
	import store from '@/store';
	import router from '@/router';
	import composableForm from '@/composables/form';
	import ReportRepository from '@/repositories/modules/Report';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const user = computed(() => store.getters['auth/user']);
			const results = ref({});

			const getResults = async () => {
				loading.value = true;

				await ReportRepository.home().then((response) => {
					results.value = response.data;
				}).catch((e) => catchError(e, true));

				loading.value = false;
			}

			const modalSelect = ref(null);
			const select = () => {
				if(loading.value) return;
				else if(results.value.balances.length == 1) router.push({ name: 'balance.show', params: { id: results.value.balances[0].id }});
				else modalSelect.value.show();
			}

			onMounted(() => getResults());

			return { loading, user, results, modalSelect, select };
		}
	}
</script>